import React from 'react';
import { Check, AlertTriangle, Zap, X, type LucideIcon } from 'lucide-react';
import { getRiskLevelColor, getRiskLevelLabel } from '@abs/shared-logic';
import { RiskLevel } from '@abs/shared-types';

export interface RiskBadgeProps {
  level: RiskLevel;
  size?: 'sm' | 'md' | 'lg';
}

const ICON_MAP: Record<RiskLevel, LucideIcon> = {
  [RiskLevel.Satisfactory]: Check,
  [RiskLevel.Warning]: AlertTriangle,
  [RiskLevel.AtRisk]: Zap,
  [RiskLevel.Critical]: X,
};

export function RiskBadge({ level, size = 'md' }: RiskBadgeProps): React.ReactElement {
  const color = getRiskLevelColor(level);
  const label = getRiskLevelLabel(level);
  const Icon = ICON_MAP[level];

  return (
    <span
      className={`risk-badge risk-badge--${size}`}
      style={{ backgroundColor: color }}
      role="status"
      aria-label={`Risk level: ${label}`}
    >
      {Icon && <Icon className="risk-badge__icon" aria-hidden="true" />}
      <span className="risk-badge__text">{label}</span>
    </span>
  );
}
